const SIZE_STYLES = {
  xxs: "size-3 text-xxs",
  xs: "w-3 h-3 text-xs",
  sm: "w-4 h-4 text-sm",
  lg: "w-6 h-6 text-xl",
}

const TONE_STYLES = {
  primary: "text-content-secondary",
  secondary: "text-gray-500",
  brand: "text-azure-500",
  link: "text-link",
  inversed: "text-white",
  success: "text-content-success-accent",
  warning: "text-content-warning-accent",
  critical: "text-content-error",
  muted: "text-gray-500 dark:text-neutral-500",
}

type IconProps = {
  name?: string
  size?: keyof typeof SIZE_STYLES
  variant?: "disclosure" | "close"
  tone?: keyof typeof TONE_STYLES
  open?: boolean
  className?: string
}

const Icon = ({ name, size = "sm", variant, tone, open = false, className = "" }: IconProps) => {
  let resolvedIcon = name
  let resolvedSize = size

  if (variant === "disclosure") {
    resolvedIcon = open ? "far fa-angle-up" : "far fa-angle-down"
    resolvedSize = "xs"
  }

  if (variant === "close") {
    resolvedIcon = "fas fa-close"
  }

  const sizeClass = SIZE_STYLES[resolvedSize] || SIZE_STYLES.sm
  const hasIcon = Boolean(resolvedIcon)
  const toneClass = tone ? TONE_STYLES[tone] : ""

  if (!hasIcon) return null

  return (
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center shrink-0 ${sizeClass}`}
    >
      <i className={`${resolvedIcon} fa-fw ${toneClass} ${className}`} />
    </span>
  )
}

export default Icon
